// This function takes two sets and returns a new set that contains only the elements in the first set that are not in the second set.
export const subtract = <A>(a: Set<A>, b: Set<A>): Set<A> => new Set([...a].filter((x) => !b.has(x)));
